var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoardBlack(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.66667H14.6667C15.1087 3.66667 15.5326 3.84226 15.8452 4.15482C16.1577 4.46738 16.3333 4.89131 16.3333 5.33333V7M6.33333 18.6667H4.66667C4.22464 18.6667 3.80072 18.4911 3.48816 18.1785C3.17559 17.866 3 17.442 3 17V5.33333C3 4.89131 3.17559 4.46738 3.48816 4.15482C3.80072 3.84226 4.22464 3.66667 4.66667 3.66667H6.33333M17.45 13.3867C17.6144 13.2223 17.7448 13.0272 17.8337 12.8124C17.9227 12.5976 17.9685 12.3675 17.9685 12.135C17.9685 11.9025 17.9227 11.6724 17.8337 11.4576C17.7448 11.2428 17.6144 11.0477 17.45 10.8833C17.2856 10.719 17.0905 10.5886 16.8757 10.4996C16.661 10.4107 16.4308 10.3649 16.1983 10.3649C15.9659 10.3649 15.7357 10.4107 15.5209 10.4996C15.3062 10.5886 15.111 10.719 14.9467 10.8833L10.7717 15.06C10.5735 15.258 10.4285 15.5028 10.35 15.7717L9.6525 18.1633C9.63159 18.235 9.63033 18.3111 9.64887 18.3834C9.66741 18.4558 9.70505 18.5218 9.75787 18.5746C9.81069 18.6274 9.87673 18.6651 9.94909 18.6836C10.0214 18.7022 10.0975 18.7009 10.1692 18.68L12.5608 17.9825C12.8297 17.904 13.0745 17.759 13.2725 17.5608L17.45 13.3867ZM7.16667 2H12.1667C12.6269 2 13 2.3731 13 2.83333V4.5C13 4.96024 12.6269 5.33333 12.1667 5.33333H7.16667C6.70643 5.33333 6.33333 4.96024 6.33333 4.5V2.83333C6.33333 2.3731 6.70643 2 7.16667 2Z",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardBlack);
export default __webpack_public_path__ + "static/media/Board_black.b9ff9273b6456f0eb9e0e3d9c5ce5919.svg";
export { ForwardRef as ReactComponent };